import { requestBaseService } from './index'

const exUrl = 'emitten/ex/v1/trading-view/'
const publicUrl = 'emitten/public/v1/trading-view/'

export const chartConfig = (payload) => {
  const baseURL = payload.isLogedIn ? exUrl : publicUrl

  return requestBaseService({
    url: baseURL + 'config',
    method: 'GET',
  })
}

const TradingView = {
  chartConfig,
}

export default TradingView
